export default "__VITE_ASSET__cSYERv3k__"